import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { downloadFinalReport } from 'services/apiReport';

const useDownloadReport = () => {
  const queryClient = useQueryClient();

  const {isPending: isDownloading,isSuccess: isDownloaded,mutate:downloadReport} = useMutation({
    mutationFn: downloadFinalReport,
  })

  return {isDownloading, isDownloaded,downloadReport}
}

export default useDownloadReport